import { E2eType, Environment } from '@sds/shared';
import type { EnvironmentType } from '../environments/environment-type';

/**
 * localStorage key that lets the mocked e2e build run in development mode, e.g. to test dev-only features.
 * It is ignored by every other build.
 */
export const E2E_ENVIRONMENT_STORAGE_KEY = 'e2e_environment';

/**
 * Returns the storage holding the e2e environment override. Only the mocked e2e build reads it; every other build
 * gets no storage, so localStorage is never touched there. Unavailable or blocked storage (e.g. SecurityError) yields none.
 */
export function getE2eEnvironmentStorage(
  environment: EnvironmentType,
  document: { readonly defaultView: { readonly localStorage: Pick<Storage, 'getItem'> } | null }
): Pick<Storage, 'getItem'> | undefined {
  if (environment.e2e !== E2eType.MOCKED) {
    return undefined;
  }
  try {
    return document.defaultView?.localStorage ?? undefined;
  } catch {
    return undefined;
  }
}

export function environmentFactory(
  environment: EnvironmentType,
  storage: Pick<Storage, 'getItem'> | null | undefined
): Environment {
  if (environment.e2e === E2eType.MOCKED && storage?.getItem(E2E_ENVIRONMENT_STORAGE_KEY) === Environment.DEV) {
    return Environment.DEV;
  }
  return environment.production ? Environment.PROD : Environment.DEV;
}
